import React, { useRef, useState } from "react";
import Tabs from "../reuseable/Tabs";
import NotificationSubscriberManagement from "./NotificationSubscriberManagement";
import NotificationSubscriberRegistration from "./NotificationSubscriberRegistration";

const NotificationManagement = () => {
  const [activeTab, setActiveTab] = useState(0);
  const managementRef = useRef(null);
  const tabs = ["SUBSCRIBER MANAGEMENT", "SUBSCRIBER REGISTRATION"];

  const handleSubscriberAdded = () => {
    if (managementRef.current) {
      managementRef.current.fetchSubscribers();
    }
  };

  return (
    <div
      style={{
        borderRadius: 8,
        padding: 32,
        minHeight: "calc(100vh - 124px)",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        display: "block",
      }}
      className="bg-[#bb1ccc]/5"
    >
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />

      {activeTab === 0 && <NotificationSubscriberManagement ref={managementRef} />}
      {activeTab === 1 && (
        <NotificationSubscriberRegistration onSubscribersChange={handleSubscriberAdded} />
      )}
    </div>
  );
};

export default NotificationManagement;